var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCorrect(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "correct 1",
    clipPath: "url(#clip0_5959_3282)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40 0C17.9375 0 0 17.9375 0 40C0 62.0625 17.9375 80 40 80C62.0625 80 80 62.0625 80 40C80 17.9375 62.0625 0 40 0Z",
    fill: "#007D23"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.3437 26.5195C60.3125 27.4883 60.3125 29.082 59.3437 30.0508L35.9062 53.4883C35.4219 53.9727 34.7812 54.2227 34.1406 54.2227C33.5 54.2227 32.8594 53.9727 32.375 53.4883L20.6562 41.7695C19.6875 40.8008 19.6875 39.207 20.6562 38.2383C21.625 37.2695 23.2188 37.2695 24.1875 38.2383L34.1406 48.1914L55.8125 26.5195C56.7812 25.5352 58.375 25.5352 59.3437 26.5195Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5959_3282"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCorrect);
export default __webpack_public_path__ + "static/media/correct.dfffcd78bbe542bb3afc216755f47b7a.svg";
export { ForwardRef as ReactComponent };